"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64EncodeURL = void 0;
/**
 * Encode a byte array to a base64URL string.
 * Taken from: https://gist.github.com/themikefuller/c1de46cbbdad02645b9dc006baedf88e
 */
function base64EncodeURL(byteArray) {
    return (btoa(Array.from(new Uint8Array(byteArray), (val) => String.fromCharCode(val)).join(""))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        // eslint-disable-next-line
        .replace(/\=/g, ""));
}
exports.base64EncodeURL = base64EncodeURL;
//# sourceMappingURL=base64Url.js.map